import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import moment from "moment";
import { selector, can } from "../../../api";
import { kayaCRUD } from "../../../actions/kaya";
import { EditKayaContent } from "../kaya/edit";
import { Footer } from "../../../layout/footer";
import { Loading } from "../../constant";
import { EditKayaMember } from "../member/edit";
import { DeadMember } from "../member/dead";
import { AddKayaMember } from "../member/modal";
import { MemberDetail } from "../member/details";
import { toast } from "react-toastify";

export const KayaMemberContent = () => {
  let location = useLocation();
  const user = selector.User();
  const [dataId] = useState(location.state.id);
  const [value, setValue] = useState("");
  const [data, setData] = useState({});
  const [building, setBuilding] = useState({});
  const [member, setMember] = useState([]);
  const [fitered, setFiltered] = useState([]);
  const [index, setIndex] = useState(0);
  const [dataIdId, setDataIdId] = useState(null);
  const [editOpen, setEditOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      kayaCRUD
        .loadKayaDetails(dataId)
        .then((resp) => {
          setData(resp.data);
          setBuilding(resp.data.kaya_building && resp.data.kaya_building[0]);
          setMember(resp.data.kaya_member);
          console.log(resp.data.kaya_member);
        })
        .finally(() => {});
    }, 2000);
  }, [dataId, index]);

  const handleValueChange = (events) => {
    const sel = events.target.value;
    setValue(sel);
    const searchTerm = sel.toLowerCase();
    const filteredData = member.filter((entry) => {
      // Search by Name (Jina)
      const nameMatch = entry.member_id?.full_name?.toLowerCase().includes(searchTerm);
      // Search by Phone Number (Nambari ya simu)
      const phoneMatch = entry.member_id?.phone_number?.toLowerCase().includes(searchTerm);
      // Search by Registration Number
      const regNoMatch = entry.member_id?.reg_no?.toLowerCase().includes(searchTerm);

      return nameMatch || phoneMatch || regNoMatch;
    });
    setFiltered(filteredData);
  };

  const results = !value ? member : fitered;

  const handleChangeId = (e) => {
    setDataIdId(e);
  };

  const handleRemove = (e) => {
    kayaCRUD.removeMember(e, { is_closed: true }).then(() => {
      toast.success("One member has been removed from this house hold.", {
        autoClose: 7000,
      });
      setIndex(index + 1);
    });
  };

  // Capability-based gate (replaces legacy group-id === 2 check).
  const canEdit = can(user, 'edit_data') || user?.admin_access === 'Shehia';

  return (
    <>
      <AddKayaMember index={index} setIndex={setIndex} kaya={dataId} />
      <EditKayaContent dataId={dataId} index={index} setIndex={setIndex} open={editOpen} setOpen={setEditOpen} />
      <EditKayaMember dataId={dataIdId} index={index} setIndex={setIndex} />
      <DeadMember dataId={dataIdId} index={index} setIndex={setIndex} />
      <MemberDetail dataId={dataIdId} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">House Hold Details</h4>

                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <Link to={"/kaya"}>House Hold</Link>
                      </li>
                      <li className="breadcrumb-item active">Details</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div
                    className="card-header"
                    data-bs-toggle="collapse"
                    data-bs-target=".close"
                  >
                    <div className="row">
                      <div className="col-sm">
                        <h4 className="card-title mt-3">House Hold</h4>
                      </div>
                      <div className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                            />
                            <i className="ri-search-line search-icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-body close">
                    <div id="customerList">
                      <div className="row g-4 mb-3">
                        <div className="col-sm-12 col-md-3">
                          <div>
                            <label for="borderInput" className="form-label">
                              Data collection
                            </label>
                            <input
                              type="text"
                              className="form-control border-dashed"
                              id="borderInput"
                              value={data.code}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                          <div>
                            <label for="borderInput" className="form-label">
                              Head Phone Number
                            </label>
                            <input
                              type="text"
                              className="form-control border-dashed"
                              id="borderInput"
                              value={
                                data
                                  ? data.head_phone_number
                                    ? data.head_phone_number
                                    : "N/A"
                                  : "N/A"
                              }
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                          <div>
                            <label for="borderInput" className="form-label">
                              Postcode
                            </label>
                            <input
                              type="text"
                              className="form-control border-dashed"
                              id="borderInput"
                              value="71112"
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                          <div>
                            <label for="borderInput" className="form-label">
                              House Number
                            </label>
                            <input
                              type="text"
                              className="form-control border-dashed"
                              id="borderInput"
                              value={
                                building
                                  ? building.building_id
                                    ? building.building_id.postcode
                                    : "N/A"
                                  : "N/A"
                              }
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-3">
                          <div>
                            <label for="borderInput" className="form-label">
                              Shehia Number
                            </label>
                            <input
                              type="text"
                              className="form-control border-dashed"
                              id="borderInput"
                              value={
                                building
                                  ? building.building_id
                                    ? "SH/" + building.building_id.house_no
                                    : "N/A"
                                  : "N/A"
                              }
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row g-4 mb-3">
                        <div className="col-sm-12 col-md-3">
                          <div>
                            <label for="borderInput" className="form-label">
                              Electricity Meter No
                            </label>
                            <input
                              type="text"
                              className="form-control border-dashed"
                              id="borderInput"
                              value={
                                building
                                  ? building.building_id
                                    ? building.building_id.elecricity_meter_no
                                    : "N/A"
                                  : "N/A"
                              }
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-3">
                          <div>
                            <label for="borderInput" className="form-label">
                              Water Meter No
                            </label>
                            <input
                              type="text"
                              className="form-control border-dashed"
                              id="borderInput"
                              value={
                                building
                                  ? building.building_id
                                    ? building.building_id.water_meter_no
                                    : "N/A"
                                  : "N/A"
                              }
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                          <div>
                            <label for="borderInput" className="form-label">
                              Number of Units
                            </label>
                            <input
                              type="number"
                              className="form-control border-dashed"
                              id="borderInput"
                              value={
                                building
                                  ? building.building_id
                                    ? building.building_id.number_of_units
                                    : 1
                                  : 1
                              }
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                          <div>
                            <label for="borderInput" className="form-label">
                              Number of Floors
                            </label>
                            <input
                              type="number"
                              className="form-control border-dashed"
                              id="borderInput"
                              value={
                                building
                                  ? building.building_id
                                    ? building.building_id.number_of_floors
                                    : 1
                                  : 1
                              }
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                          <div
                            className="form-check form-switch form-switch-lg form-switch-success"
                            style={{ marginTop: 30, marginLeft: 20 }}
                            dir="ltr"
                          >
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={
                                building
                                  ? building.building_id
                                    ? building.building_id.is_condominium
                                      ? true
                                      : false
                                    : false
                                  : false
                              }
                              id="customSwitchsizelg"
                            />
                            <label
                              className="form-check-label"
                              for="customSwitchsizelg"
                            >
                              Condominium
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row g-4 mb-3">
                        <div className="col-sm-12 col-md-3">
                          <div>
                            <label for="borderInput" className="form-label">
                              Distance to health center
                            </label>
                            <input
                              type="text"
                              className="form-control border-dashed"
                              value={
                                data.distance_to_health_center
                                  ? data.distance_to_health_center
                                  : "N/A"
                              }
                              id="borderInput"
                              placeholder="Enter your name"
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-3">
                          <div>
                            <label for="borderInput" className="form-label">
                              Distance to education center
                            </label>
                            <input
                              type="text"
                              className="form-control border-dashed"
                              value={
                                data.distance_to_education_center
                                  ? data.distance_to_education_center
                                  : "N/A"
                              }
                              id="borderInput"
                              placeholder="Enter your name"
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                          <div>
                            <label for="borderInput" className="form-label">
                              Distance to market
                            </label>
                            <input
                              type="text"
                              className="form-control border-dashed"
                              value={
                                data.distance_to_market
                                  ? data.distance_to_market
                                  : "N/A"
                              }
                              id="borderInput"
                              placeholder="Enter your name"
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                          <div>
                            <label for="borderInput" className="form-label">
                              Distance to water source
                            </label>
                            <input
                              type="text"
                              className="form-control border-dashed"
                              value={
                                data.distance_to_water_source
                                  ? data.distance_to_water_source
                                  : "N/A"
                              }
                              id="borderInput"
                              placeholder="Enter your name"
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                          <div
                            className="form-check form-switch form-switch-lg form-switch-success"
                            style={{ marginTop: 30, marginLeft: 20 }}
                            dir="ltr"
                          >
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={
                                data
                                  ? data.is_toilet_available
                                    ? true
                                    : false
                                  : false
                              }
                              id="customSwitchsizelg"
                            />
                            <label
                              className="form-check-label"
                              for="customSwitchsizelg"
                            >
                              Toilet Available
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="d-flex justify-content-end">
                      <div className="pagination-wrap hstack gap-2">
                        {canEdit && (
                          <a
                            className="btn btn-soft-warning"
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setEditOpen(true);
                            }}
                          >
                            <i className="bi bi-pencil-square"></i> Edit
                          </a>
                        )}
                        <ul className="pagination listjs-pagination mb-0"></ul>
                        {building && building.building_id && (
                          <Link
                            className="btn btn-soft-success"
                            to={"/map"}
                            state={{
                              type: "building",
                              id: building.building_id.id,
                            }}
                          >
                            <i className="bi bi-geo-alt"></i> Map
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col-sm">
                        <h4 className="card-title mt-3">Member</h4>
                      </div>
                      <div className="col-sm">
                        {canEdit && (
                          <div className="row d-flex justify-content-end">
                            <div className="col-auto">
                              <Link
                                to={"/new"}
                                className="btn btn-soft-primary"
                                data-bs-toggle="modal"
                                data-bs-target=".bs-example-modal-lg"
                              >
                                <i className="bi bi-plus-circle bi-lg"></i>{" "}
                                &nbsp; New Member
                              </Link>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              value={value}
                              onChange={handleValueChange}
                              placeholder="Tafuta kwa Jina, Simu..."
                            />
                            <i className="ri-search-line search-icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body tableFixHead">
                    <table
                      id="scroll-vertical"
                      className="table table-bordered dt-responsive nowrap table-striped align-middle mdl-data-table"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th>SR No.</th>
                          <th>Reg Number</th>
                          <th>Full Name</th>
                          <th>Gender</th>
                          <th>Birth Date</th>
                          <th>Birth Place</th>
                          <th>Phone Number</th>
                          <th>Relation to Head</th>
                          <th>Merital Status</th>
                          <th className="d-flex justify-content-center">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {results?.map(
                          (dt, i) =>
                            dt.member_id && (
                              <tr
                                className={
                                  dt.member_id.is_dead ? "bg-soft-danger" : ""
                                }
                              >
                                <td>{i + 1}</td>
                                <td>
                                  {dt.member_id ? dt.member_id.reg_no : "N/A"}
                                </td>
                                <td>
                                  {dt.member_id
                                    ? dt.member_id.full_name.toUpperCase()
                                    : "N/A"}
                                </td>
                                <td>
                                  {dt.member_id.dictionary_gender
                                    ? dt.member_id.dictionary_gender.dictionary_item_name_en.toUpperCase()
                                    : "N/A"}
                                </td>
                                <td>
                                  {moment(dt.member_id.dob).format(
                                    "D MMM, YYYY"
                                  )}
                                </td>
                                <td>
                                  {dt.member_id.pob
                                    ? dt.member_id.pob.toUpperCase()
                                    : "N/A"}
                                </td>
                                <td>
                                  {dt.member_id.phone_number
                                    ? dt.member_id.phone_number
                                    : "N/A"}
                                </td>
                                <td>
                                  {dt.member_id.dictionary_relation_to_head
                                    ? dt.member_id.dictionary_relation_to_head.dictionary_item_name_en.toUpperCase()
                                    : "N/A"}
                                </td>
                                <td>
                                  {dt.member_id.dictionary_marital_status
                                    ? dt.member_id.dictionary_marital_status.dictionary_item_name_en.toUpperCase()
                                    : "N/A"}
                                </td>
                                <td className="text-center">
                                  <div className="dropdown d-inline-block">
                                    <button
                                      className="btn btn-soft-secondary btn-sm dropdown"
                                      type="button"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i className="ri-more-2-fill align-middle"></i>
                                    </button>
                                    <ul className="dropdown-menu dropdown-menu-end">
                                      <li>
                                        <Link
                                          to={"/new"}
                                          onClick={() =>
                                            handleChangeId(dt.member_id.id)
                                          }
                                          data-bs-toggle="modal"
                                          data-bs-target=".detailModal"
                                          className="dropdown-item"
                                        >
                                          <i className="ri-eye-fill align-bottom me-2 text-muted"></i>{" "}
                                          View
                                        </Link>
                                      </li>
                                      {canEdit && (
                                        <>
                                          <li>
                                            <Link
                                              to={"/new"}
                                              onClick={() =>
                                                handleChangeId(dt.member_id.id)
                                              }
                                              data-bs-toggle="modal"
                                              data-bs-target=".editmodal"
                                              className="dropdown-item edit-item-btn"
                                            >
                                              <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>{" "}
                                              Edit
                                            </Link>
                                          </li>
                                          <li>
                                            <button
                                              onClick={() =>
                                                handleRemove(dt.member_id.id)
                                              }
                                              className="dropdown-item edit-item-btn"
                                            >
                                              <i className="ri-shut-down-line align-bottom me-2 text-muted"></i>{" "}
                                              Remove
                                            </button>
                                          </li>
                                          <li>
                                            <Link
                                              to={"/new"}
                                              onClick={() =>
                                                handleChangeId(dt.member_id.id)
                                              }
                                              data-bs-toggle="modal"
                                              data-bs-target=".deadModal"
                                              className="dropdown-item edit-item-btn"
                                            >
                                              <i className="ri-forbid-2-line align-bottom me-2 text-muted"></i>{" "}
                                              Dead
                                            </Link>
                                          </li>
                                        </>
                                      )}
                                      <li>
                                        {building ? (
                                          <Link
                                            to={"/map"}
                                            state={{
                                              type: "building",
                                              id: building.building_id.id,
                                            }}
                                            className="dropdown-item remove-item-btn"
                                          >
                                            <i className="ri-map-pin-line align-bottom me-2 text-muted"></i>{" "}
                                            Map
                                          </Link>
                                        ) : (
                                          <a
                                            href="javascript:void(0);"
                                            className="dropdown-item remove-item-btn"
                                          >
                                            <i className="ri-map-pin-line align-bottom me-2 text-muted"></i>{" "}
                                            Map
                                          </a>
                                        )}
                                      </li>
                                    </ul>
                                  </div>
                                </td>
                              </tr>
                            )
                        )}
                      </tbody>
                    </table>
                    <div className="row">{!results.length && <Loading />}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};
